export const PHONE_DISPLAY = "+27 74 218 3329";
export const PHONE_LOCAL = "074 218 3329";
export const WA_LINK = "https://wa.me/27742183329";
export const EMAIL = "autocitylubs@gmail.com";
export const ADDRESS = "91A Sunny Road, Lakefield, Benoni, 1501, South Africa";
export const waMessage = (msg) => `${WA_LINK}?text=${encodeURIComponent(msg)}`;
export const DEFAULT_WA_MSG =
  "Hello Auto City Lubricants, I would like to inquire about bulk lubricant supply.";
export const DATA_SHEETS_EMAIL_LINK =
  "mailto:autocitylubs@gmail.com?subject=" +
  encodeURIComponent("MSDS & TDS Request — Auto City Lubricants") +
  "&body=" +
  encodeURIComponent(
    "Hello Auto City Lubricants, please send me the Material Safety Data Sheet (MSDS) and Technical Data Sheet (TDS) for your products."
  );
